import { withInstall } from '@ll-plus/utils'

import RankingList from './src/ranking-list.vue'

export const LlRankingList = withInstall(RankingList)
export default LlRankingList
export * from './src/ranking-list'

declare module 'vue' {
  export interface GlobalComponents {
    LlRankingList: typeof RankingList
  }
}
